import React from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import WindowGlassBanner from "../../../Assets/Product_Images/WindowGlass/window-banner.jpg";
import GlassImage1 from "../../../Assets/Product_Images/WindowGlass/glass-window-1.png";
import GlassImage2 from "../../../Assets/Product_Images/WindowGlass/glass-window-2.png";
import GlassImage3 from "../../../Assets/Product_Images/WindowGlass/glass-window-3.png";
import GlassImage4 from "../../../Assets/Product_Images/WindowGlass/glass-window-4.jpeg";
import GlassImage5 from "../../../Assets/Product_Images/WindowGlass/bus4.jpg";
import GlassImage6 from "../../../Assets/Product_Images/WindowGlass/bus2.jpg";
import RailwayWindowGlass2 from "../../../Assets/Product_Images/RailwayWindowGlass/RailwayWindowGlass2.webp";
import RailwayWindowGlass3 from "../../../Assets/Product_Images/RailwayWindowGlass/RailwayWindowGlass3.jpg";

import { Link } from "react-router-dom";

const Automobile_glass = () => {
  return (
    <div>
      <Header />
      {/* banner section start  */}
      <section
        className="container-fluid common_banner"
        style={{

          backgroundImage: `url(${WindowGlassBanner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeaNt",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="common_title wow fadeInUp">
                <h2>
                  <Link
                    to="/AboutUs"
                    className="text-decoration-none text-white"
                  >
                    ABOUT US
                  </Link>{" "}
                  /{" "}
                  <span className="text-white">
                    Automotive & Railway Window Glass
                  </span>
                </h2>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* banner section end */}

      {/* about tabbing section start  */}
      <section className="container-fluid about_Products_section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="blog_text wow fadeInUp">
                <h5
                  style={{
                    color: "#153fa4",
                    fontFamily: "Segoe UI, sans-serif",
                    fontSize: "40px",
                    fontWeight: "700",
                    marginBottom: "15px",
                  }}
                >
                  Automotive & Railway Window Glass
                </h5>
                <p>
                  At Khodiyar Automotive Glass Pvt. Ltd., we manufacture
                  high-quality window glass solutions designed for automotive,
                  railway, and commercial transportation applications. Our
                  products are engineered to provide superior safety,
                  durability, comfort, and visibility while meeting modern
                  industry standards.
                </p>
                <p>
                  Our range includes side window glasses for buses, cars, and
                  railway coaches, manufactured with excellent optical clarity,
                  smooth finishing, and long-lasting performance. Available in
                  fixed and sliding panel configurations, these windows offer
                  flexibility in design, ventilation, and passenger comfort.
                </p>
                <p>
                  For railway applications, our window glass is specially
                  developed to withstand high wind pressure, temperature
                  fluctuations, vibration, and impact from external debris. We
                  utilize advanced laminated and insulated glass technologies to
                  enhance passenger safety and improve overall travel comfort.
                </p>
                <p>
                  Laminated glass helps reduce injury risks by remaining intact
                  even when cracked, while insulated glass units provide
                  excellent thermal and acoustic insulation, creating a quieter
                  and more energy-efficient environment. Additionally, our glass
                  products can be enhanced with UV protection, scratch-resistant
                  coatings, and other specialized treatments to ensure long-term
                  performance and clarity.
                </p>
                <h4
                  style={{
                    color: "#153fa4",
                    fontWeight: "700",
                    marginTop: "25px",
                    marginBottom: "15px",
                  }}
                >
                  Key Features
                </h4>

                <ul
                  style={{
                    paddingLeft: "20px",
                    lineHeight: "2",
                  }}
                >
                  <li>High impact and break resistance</li>
                  <li>
                    Enhanced passenger safety with laminated glass technology
                  </li>
                  <li>Excellent thermal and acoustic insulation</li>
                  <li>UV-resistant and scratch-resistant surface options</li>
                  <li>Available in fixed and sliding window configurations</li>
                  <li>Superior optical clarity and smooth finish</li>
                  <li>Durable performance under extreme weather conditions</li>
                  <li>Customizable sizes and specifications</li>
                  <li>
                    Suitable for buses, cars, railway coaches, and commercial
                    vehicles
                  </li>
                  <li>
                    Long service life with minimal maintenance requirements
                  </li>
                </ul>
              </div>
              <div className="Products_img  gap-5 mt-5 wow fadeInUp">
                <img
                  src={RailwayWindowGlass2}
                  className="RailwayWindowGlass2"
                  style={{ width: "180px", height: "180px" }}
                  alt="Bus"
                />
                <img
                  src={GlassImage2}
                  className="GlassImage2"
                  style={{ width: "180px", height: "180px" }}
                  alt="car"
                />
                <img
                  src={GlassImage1}
                  className="GlassImage1"
                  style={{ width: "180px", height: "180px" }}
                  alt="staff-bus"
                />
                <img
                  src={GlassImage3}
                  className="GlassImage3"
                  style={{ width: "180px", height: "180px" }}
                  alt="Bus"
                />
                <img
                  src={GlassImage4}
                  className="GlassImage4"
                  style={{ width: "180px", height: "180px" }}
                  alt="car"
                />
                {/* <img
                  src={GlassImage6}
                  className="GlassImage6"
                  style={{ width: "180px", height: "180px" }}
                  alt="staff-bus"
                /> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* about tabbing section End  */}

      <Footer />
    </div>
  );
};

export default Automobile_glass;
